export function icon_pionter() {

  //マウスホバー
  // $(function() {
  //   const $items = $('.c-btn_pionter');
  //   const $pointer = $('.pointer');
  
  //   $items.on({
  //     mouseenter: function(event) {
  //       $pointer.addClass('-isShown');
  //       movePointer(event);
  //     },
  //     mousemove: function(event) {
  //       movePointer(event);
  //     },
  //     mouseleave: function() {
  //       $pointer.removeClass('-isShown');
  //     }
  //   });
  
  //   function movePointer(event) {
  //     const x = event.clientX;
  //     const y = event.clientY;
  //     $pointer.css('transform', `translate(${x}px, ${y}px)`);
  //   }
  // });

  $(function () {
    $('.c-btn_pionter').on({
      mouseenter: function (event) {
        let $pointer = $(this).children('.pointer');

        if (!$pointer.length) {
          $pointer = $('<span class="pointer"></span>').appendTo(this);
        }

        $pointer.addClass('is-show');
        movePointer(event, $pointer);
      },
      mousemove: function (event) {
        const $pointer = $(this).children('.pointer');
        if ($pointer.length) {
          movePointer(event, $pointer);
        }
      },
      mouseleave: function () {
        $(this).children('.pointer').removeClass('is-show');
      }
    });

    function movePointer(event, $pointer) {
      const rect = event.currentTarget.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      $pointer.css('transform', `translate(${x}px, ${y}px)`);
    }
  });

}